import apiClient from '../lib/apiClient';

const activityLogService = {
  // Log an activity
  logActivity: async (activityData) => {
    try {
      const result = await apiClient.post('/activity/log', activityData);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to log activity' };
    }
  },

  // Get activity logs with optional filters
  getActivityLogs: async (filters = {}) => {
    try {
      const result = await apiClient.get('/activity', filters);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch activity logs' };
    }
  },

  // Get recent activities for dashboard
  getRecentActivities: async (limit = 10) => {
    try {
      const result = await apiClient.get('/activity/recent', { limit });
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch recent activities' };
    }
  },

  // Get activity statistics
  getActivityStats: async (timeFrame = '7_days') => {
    try {
      const result = await apiClient.get('/activity/stats', { timeFrame });
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch activity statistics' };
    }
  }
};

export default activityLogService;
